// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/notification.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateWebhookRequest, DeleteWebhookRequest, GetPreferencesRequest, GetPreferencesResponse, GetUnreadCountRequest, GetUnreadCountResponse, ListEventTypesRequest, ListEventTypesResponse, ListNotificationsRequest, ListNotificationsResponse, ListWebhookDeliveriesRequest, ListWebhookDeliveriesResponse, ListWebhookEventTypesRequest, ListWebhookEventTypesResponse, ListWebhooksRequest, ListWebhooksResponse, MarkAllReadRequest, MarkAllReadResponse, MarkReadRequest, MarkReadResponse, RegisterDeviceRequest, RegisterDeviceResponse, TestWebhookRequest, TestWebhookResponse, UnregisterDeviceRequest, UnregisterDeviceResponse, UpdatePreferenceRequest, UpdatePreferenceResponse, UpdateWebhookRequest, WebhookSubscription } from "./notification_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.NotificationService
 */
export const NotificationService = {
  typeName: "omnios.v1.NotificationService",
  methods: {
    /**
     * @generated from rpc omnios.v1.NotificationService.ListNotifications
     */
    listNotifications: {
      name: "ListNotifications",
      I: ListNotificationsRequest,
      O: ListNotificationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.MarkRead
     */
    markRead: {
      name: "MarkRead",
      I: MarkReadRequest,
      O: MarkReadResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.MarkAllRead
     */
    markAllRead: {
      name: "MarkAllRead",
      I: MarkAllReadRequest,
      O: MarkAllReadResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.GetUnreadCount
     */
    getUnreadCount: {
      name: "GetUnreadCount",
      I: GetUnreadCountRequest,
      O: GetUnreadCountResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.RegisterDevice
     */
    registerDevice: {
      name: "RegisterDevice",
      I: RegisterDeviceRequest,
      O: RegisterDeviceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.UnregisterDevice
     */
    unregisterDevice: {
      name: "UnregisterDevice",
      I: UnregisterDeviceRequest,
      O: UnregisterDeviceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.GetPreferences
     */
    getPreferences: {
      name: "GetPreferences",
      I: GetPreferencesRequest,
      O: GetPreferencesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.UpdatePreference
     */
    updatePreference: {
      name: "UpdatePreference",
      I: UpdatePreferenceRequest,
      O: UpdatePreferenceResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.ListEventTypes
     */
    listEventTypes: {
      name: "ListEventTypes",
      I: ListEventTypesRequest,
      O: ListEventTypesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Webhooks
     *
     * @generated from rpc omnios.v1.NotificationService.CreateWebhook
     */
    createWebhook: {
      name: "CreateWebhook",
      I: CreateWebhookRequest,
      O: WebhookSubscription,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.UpdateWebhook
     */
    updateWebhook: {
      name: "UpdateWebhook",
      I: UpdateWebhookRequest,
      O: WebhookSubscription,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.DeleteWebhook
     */
    deleteWebhook: {
      name: "DeleteWebhook",
      I: DeleteWebhookRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.ListWebhooks
     */
    listWebhooks: {
      name: "ListWebhooks",
      I: ListWebhooksRequest,
      O: ListWebhooksResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.TestWebhook
     */
    testWebhook: {
      name: "TestWebhook",
      I: TestWebhookRequest,
      O: TestWebhookResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.ListWebhookDeliveries
     */
    listWebhookDeliveries: {
      name: "ListWebhookDeliveries",
      I: ListWebhookDeliveriesRequest,
      O: ListWebhookDeliveriesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.NotificationService.ListWebhookEventTypes
     */
    listWebhookEventTypes: {
      name: "ListWebhookEventTypes",
      I: ListWebhookEventTypesRequest,
      O: ListWebhookEventTypesResponse,
      kind: MethodKind.Unary,
    },
  }
};

